import { generateRequestActions, createRequestTypes } from 'utils/actionHelpers/actionHelpers'

export const GET_SURVEY = createRequestTypes('GET_SURVEY')
export const GET_SURVEY_QUESTIONS = createRequestTypes('GET_SURVEY_QUESTIONS')
export const SUBMIT_SURVEY_FORM = createRequestTypes('SUBMIT_SURVEY_FORM')

export const getSurvey = generateRequestActions(GET_SURVEY)
export const getSurveyQuestions = generateRequestActions(GET_SURVEY_QUESTIONS)
export const submitSurveyForm = generateRequestActions(SUBMIT_SURVEY_FORM)
